import { TEMPLATE_FIELD_KINDS, templateFieldWrapperClass } from '../templateFields';

const OPEN_TAG = new RegExp(`<(${TEMPLATE_FIELD_KINDS.map((kind) => kind.name).join('|')})(?=[\\s>])([^>]*)>`, 'g');

/**
 * Puts the wrapper class on every bare `<template-field-*>` opening tag, string-level, so stored html
 * can be shown before `renderContent` has run without a field changing shape once it lands.
 */
export const wrapTemplateFieldTags = (html: string): string =>
  html.replace(OPEN_TAG, (tag: string, name: string, attrs: string) =>
    /\sclass=/.test(attrs) ? tag : `<${name} class="${templateFieldWrapperClass(name)}"${attrs}>`
  );
